import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ToastrService } from '@shared/services/toastr.service';
import { AuthService } from '@shared/services/auth.service';
import { debounceTime, fromEvent } from 'rxjs';
import { OrganizationSiteShareService, SentSiteShare } from '@shared/services/organization-site-share.service';
import { ConfirmService } from '@shared/services/confirm.service';
import { FormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@siemens/ngx-datatable';
import { TypedTemplateDirective } from '@shared/directives/typed-template.directive';
import { BadgeOrganizationComponent } from '@shared/components/badge-organization/badge-organization.component';
import { LabelShareRoleComponent } from '@shared/components/label-share-role/label-share-role.component';
import { LowerCasePipe } from '@angular/common';
import * as pager from '@shared/pager';

@Component({
  selector: 'app-sent-shares',
  templateUrl: './sent-shares.component.html',
  styleUrls: ['./sent-shares.component.scss'],
  imports: [
    FormsModule,
    NgxDatatableModule,
    TypedTemplateDirective,
    BadgeOrganizationComponent,
    LabelShareRoleComponent,
    LowerCasePipe,
    TranslatePipe,
  ],
})
export class SentSharesComponent implements OnInit {
  lang: string;

  @ViewChild('search') search: ElementRef;
  searchTerm: string = '';

  shares: SentSiteShare[] = [];
  page = 0;
  size = 10;
  total = 0;

  rowType = { row: {} as SentSiteShare };

  constructor(
    private auth: AuthService,
    private organizationSiteShareService: OrganizationSiteShareService,
    public translate: TranslateService,
    private toastr: ToastrService,
    private confirmService: ConfirmService,
  ) {
    this.lang = this.auth.getCurrentLanguage();
  }

  ngOnInit() {
    this.getSentShares(this.page);
  }

  ngAfterViewInit() {
    fromEvent(this.search.nativeElement, 'keyup')
      .pipe(debounceTime(500))
      .subscribe((evt: any) => {
        this.getSentShares(this.page);
      });
  }

  getSentShares(page) {
    this.organizationSiteShareService
      .getSentSiteShares({ filter: this.searchTerm }, { page, size: this.size })
      .subscribe((res) => {
        this.shares = res.content;
        this.total = res.totalElements;
      });
  }

  changePage(e) {
    this.page = e.page - 1;
    this.getSentShares(this.page);
  }

  showModalDelete(item: SentSiteShare) {
    this.confirmService.confirm({ html: this.translate.instant('DeleteShare', { item: item.site.domainName }) }, () =>
      this.deleteShare(item),
    );
  }

  deleteShare(item) {
    this.organizationSiteShareService.deleteShare(item.site.name, item.recipient.code).subscribe((res) => {
      this.getSentShares(this.page);
      this.toastr.success();
    });
  }

  protected readonly pager = pager;
}
